export default __webpack_public_path__ + "static/media/healthscan-empty-list-warning-illustration.badebe3c.svg";